import API_BASE, { withApiCredentials } from "../../api";


export async function updateFavoriteSpotHabitat(setting, token) {
  const response = await fetch(
    `${API_BASE}/auth/favorite-spots/habitat-context`,
    withApiCredentials({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify({
        ...(Object.prototype.hasOwnProperty.call(setting || {}, "platform") ? { platform: setting.platform } : {}),
        spot_key: String(setting?.spotKey || ""),
        habitat_features: Array.isArray(setting?.habitatFeatures)
          ? setting.habitatFeatures
          : [],
        access_context: setting?.accessContext ?? null,
      }),
    })
  );

  if (!response.ok) {
    throw new Error("Failed to save favorite spot fishing setting");
  }

  return response.json();
}
